import { Document, Page, pdf, Text, View } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { IntlProvider } from 'react-intl';

import { DataboxTitleContainer, WrappableDataboxContainer } from '@/utils/export/components/databox/databox';
import Footer from '@/utils/export/components/footer/footer';
import Header from '@/utils/export/components/header/header';
import exportResponseToPDFNewStyles from '@/utils/export/exportResponseToPDF/exportResponseToPDFNew.styles';
import FontProvider from '@/utils/export/utils/fontProvider/FontProvider';
import { renderMarkdownString } from '@/utils/export/utils/renderNodeToPDF/renderNodeToPDF';
import {usePdfLabels} from "@/utils/export/utils/usePdfLabls";

const SummaryBlock = ({ title, content }: { title: string; content: string }) => (
    <View style={exportResponseToPDFNewStyles.marginTop}>
        <WrappableDataboxContainer>
            <DataboxTitleContainer>
                <Text style={exportResponseToPDFNewStyles.marginLeft}>{title}</Text>
            </DataboxTitleContainer>
            <View style={exportResponseToPDFNewStyles.marginTop}>{renderMarkdownString(content, true)}</View>
        </WrappableDataboxContainer>
    </View>
);

const MyDocument = ({ message }: { message: string; }) => {
    const { answerTableTitle } = usePdfLabels();

    return (
        <FontProvider locale="en">
                <Document>
                    <Page
                        size="A4"
                        style={exportResponseToPDFNewStyles.page}
                        orientation="landscape"
                    >
                        <Header isFull={false} />
                        <SummaryBlock title={answerTableTitle} content={message} />
                        <Footer />
                    </Page>
                </Document>
        </FontProvider>
    );
};

export const exportOnlyTableResponseToPDFNew = async (message: string, messages: Record<string, string>) => {

    const date = new Date().toISOString().slice(0, 10).replace(/-/g, "_");
    const fileName = `FleetAssistant_${date}.pdf`;

    const blob = await pdf(
        <IntlProvider locale="en" messages={messages}>
            <MyDocument message={message} />
        </IntlProvider>
    ).toBlob();

    saveAs(blob, fileName);
};
